export class Ticket {

    constructor(
        public usuario: string,
        public nombre: string,
        public email: string,
        public telefono: string,
        public extension: string,
        public sitio_ayuda: string,
        public area: string,
        public piso: string,
        public asunto: string,
        public mensaje: string
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/ticket/ticket.ts